import $ from "jquery";
import slick from "slick-carousel";

(function ($) {
	$(".slider--mobile").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		prevArrow: '<button type="button" class="slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-next"></button>',
		// dots: true,
		arrows: true,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 768,
				settings: "unslick",
			},
		],
	});
});
